
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
name: 'deviceEdit',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group,Radio,Datetime,XSwitch
},
data() {
return {
stringValue:'',
stingTitle:'',
locations:[
{
key:0,
value:'店外（开锁成功播报）'
},
{
key:1,
value:'店内（进店后播报）'
},
],
location:1,
formData:{
id:0,
volume:26,
num:1,
location:1,
content:'',
open_state:0,
upload_state:0,
open_minute:0,
open_start_time:'',
open_end_time:'',
open_week:127,
},
datetimeStatus:false,
datetimeStatus1:false,
airTemperatureLoading:false,
weekOptions:[
{value:1,text:'周日'},
{value:2,text:'周一'},
{value:4,text:'周二'},
{value:8,text:'周三'},
{value:16,text:'周四'},
{value:32,text:'周五'},
{value:64,text:'周六'},
],
colors:[
{id:1,name:'红',color:'#FE5448'},
{id:2,name:'黄',color:'#FFCD35'},
{id:3,name:'蓝',color:'#326FFA'},
{id:4,name:'绿',color:'#2ECC71'},
{id:5,name:'青',color:'#00FFFF'},
{id:6,name:'白',color:'#FFFFFF'},
{id:7,name:'紫',color:'#9B59B6'},
]
}
},
created() {
this.formData.id = Number(this.$route.params.id);
this.getDeviceInfo();
this.config();
},
computed:{
speakerVolumeMin(){
return 1;
},
speakerVolumeMax(){
return this.formData.device_type == 2 ? 100 : 9;
},
speakerVolumeRange(){
return this.speakerVolumeMin + '~' + this.speakerVolumeMax;
},
speakerVolumeTip(){
return this.formData.device_type == 2 ? '新版云喇叭请输入1~100，默认80' : '旧版云喇叭请输入1~9，默认5';
},
lightColors(){
if(this.formData.device_type == 2){
return [
{id:1,name:'蓝',color:'#326FFA'},
{id:2,name:'绿',color:'#2ECC71'},
{id:3,name:'青',color:'#00FFFF'},
{id:4,name:'红',color:'#FE5448'},
{id:5,name:'紫',color:'#9B59B6'},
{id:6,name:'黄',color:'#FFCD35'},
{id:7,name:'白',color:'#FFFFFF'},
];
}
return this.colors;
},
},
methods: {
changeOpenState(val){
console.log(val);
this.stingTitle = val > 0 ? '打开' : '关闭';
},
isWeekSelected(value){
return (parseInt(this.formData.open_week) & value) > 0;
},
toggleOpenWeek(value){
let week = parseInt(this.formData.open_week) || 0;
if((week & value) > 0){
week = week & ~value;
}else{
week = week | value;
}
week = week & 127;
if(week <= 0){
this.$func.showToast('至少选择一天');
return false;
}
this.formData.open_week = week;
},
datetimeChange(val){
this.formData.open_start_time = this.normalizeClockTime(val);
},
datetimeChange1(val){
this.formData.open_end_time = this.normalizeClockTime(val);
},
changeLocation(val){
this.formData.location = val;
if(this.formData.type == 2){
this.formData.open_minute = parseInt(val) == 1 ? 3 : 0;
}
},
changeAirTemperature(step){
let value = parseInt(this.formData.volume) || 26;
value += step;
if(value < 16){
value = 16;
}
if(value > 31){
value = 31;
}
this.formData.volume = value;
this.syncAirTemperature();
},
syncAirTemperature(){
if(this.formData.type != 4 || this.airTemperatureLoading){
return false;
}
let volume = parseInt(this.formData.volume) || 26;
if(volume < 16){
volume = 16;
}
if(volume > 31){
volume = 31;
}
this.formData.volume = volume;
this.airTemperatureLoading = true;
this.$api.airSetTemperature({
id:this.formData.id,
temperature:volume
}).then((res)=>{
if(res && res.code == 0){
this.formData.state = 1;
this.$func.showToast('空调已开启，温度' + volume + '℃');
}
this.airTemperatureLoading = false;
}).catch(()=>{
this.airTemperatureLoading = false;
});
},
goAirPair(){
this.$router.push({name:'airPair',params:{id:this.formData.id}})
},
normalizeClockTime(value){
if(value === undefined || value === null){
return '';
}
value = String(value).trim();
if(!value || value == '开始时间' || value == '结束时间'){
return '';
}
let match = value.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
if(!match){
return '';
}
let hour = parseInt(match[1]);
let minute = parseInt(match[2]);
if(hour < 0 || hour > 23 || minute < 0 || minute > 59){
return '';
}
return (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
},
normalizeAirSetting(){
let volume = parseInt(this.formData.volume);
if(!volume){
volume = 26;
}
if(volume < 16){
volume = 16;
}
if(volume > 31){
volume = 31;
}
this.formData.volume = volume;
this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
let week = parseInt(this.formData.open_week);
if(!week || week < 1 || week > 127){
week = 127;
}
this.formData.open_week = week & 127;
},
normalizeLockSetting(){
this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
let week = parseInt(this.formData.open_week);
if(!week || week < 1 || week > 127){
week = 127;
}
this.formData.open_week = week & 127;
},
normalizeSwitchSetting(){
this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
this.formData.open_start_time = this.normalizeClockTime(this.formData.open_start_time);
this.formData.open_end_time = this.normalizeClockTime(this.formData.open_end_time);
let week = parseInt(this.formData.open_week);
if(!week || week < 1 || week > 127){
week = 127;
}
this.formData.open_week = week & 127;
},
normalizeSpeakerSetting(data){
this.formData.location = parseInt(this.formData.location) || 0;
let hasDelay = data && data.open_minute !== undefined && data.open_minute !== null && data.open_minute !== '';
if(hasDelay){
this.formData.open_minute = parseInt(data.open_minute) || 0;
}else{
this.formData.open_minute = this.formData.location == 1 ? 3 : 0;
}
},
normalizeLightSetting(){
this.formData.open_state = parseInt(this.formData.open_state) > 0 ? '1' : '0';
this.formData.upload_state = parseInt(this.formData.upload_state) > 0 ? '1' : '0';
this.formData.volume = parseInt(this.formData.volume) || 1;
this.formData.open_minute = parseInt(this.formData.open_minute) || 30;
this.formData.num = parseInt(this.formData.num) || 1;
if(this.formData.num < 1){
this.formData.num = 1;
}
if(this.formData.num > 9){
this.formData.num = 9;
}
},
getDeviceInfo(){
this.$api.getDeviceInfo({id:this.formData.id}).then((res)=>{
if(res){
this.formData = Object.assign({}, this.formData, res.data);
this.location = res.data.location;
if(this.formData.type == 1){
this.normalizeLockSetting();
}
if(this.formData.type == 2){
this.normalizeSpeakerSetting(res.data);
}
if(this.formData.type == 3){
this.normalizeSwitchSetting();
}
if(this.formData.type == 4){
this.normalizeAirSetting();
}
if(this.formData.type == 5){
this.normalizeLightSetting();
}
}
})
},
submit() {
if(this.formData.type == 1){
this.normalizeLockSetting();
if(this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)){
this.$func.showToast('请选择开锁时间');
return false;
}
if(this.formData.open_state > 0 && !this.formData.open_week){
this.$func.showToast('请选择开锁星期');
return false;
}
}
if(this.formData.type == 2){
let openMinute = parseInt(this.formData.open_minute);
if(isNaN(openMinute)){
openMinute = parseInt(this.formData.location) == 1 ? 3 : 0;
}
if(openMinute < 0){
openMinute = 0;
}
if(openMinute > 300){
openMinute = 300;
}
this.formData.open_minute = openMinute;
}
if(this.formData.type == 3){
this.normalizeSwitchSetting();
if(this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)){
this.$func.showToast('请选择每日常亮时间');
return false;
}
if(this.formData.open_state > 0 && !this.formData.open_week){
this.$func.showToast('请选择常亮星期');
return false;
}
}
if(this.formData.type == 4){
this.normalizeAirSetting();
if(this.formData.open_state > 0 && (!this.formData.open_start_time || !this.formData.open_end_time)){
this.$func.showToast('请选择自动开启和关闭时间');
return false;
}
if(this.formData.open_state > 0 && !this.formData.open_week){
this.$func.showToast('请选择自动开启星期');
return false;
}
}
if(this.formData.type == 5){
this.normalizeLightSetting();
}
this.$api.deviceSetting(this.formData).then((res)=>{
if(res.code == 0){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['qrCode'],
success: function (res) {
setTimeout(()=>{
if(res.resultStr.indexOf(",") != -1){
that.formData.code = that.$func.parseScanResult(res.resultStr);
}else{
that.formData.code = that.$func.parseScanResult(res.resultStr);
}
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/deviceSetting.vue